import { Group, Shape } from "paper/dist/paper-core";
import { BORDER_COLOR, CANVAS_CENTER } from "../../constants";
import { delay } from "../utils/delay";

export default class Eyes extends Group {
  constructor() {
    const left = new Shape.Circle({
      center: [CANVAS_CENTER - 7, 39],
      radius: 1,
      fillColor: BORDER_COLOR,
    });
    const right = new Shape.Circle({
      center: [CANVAS_CENTER + 7, 39],
      radius: 1,
      fillColor: BORDER_COLOR,
    });
    super([left, right]);
  }

  blink = () =>
    new Promise((resolve) => {
      this.tweenTo({ opacity: 0 }, 50)
        .then(() => delay(750))
        .then(() => {
          this.tweenTo({ opacity: 1 }, 50).then(resolve);
        });
    });
}
